import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Stack } from "@curves/ui-base";
import handheldScannerIcon from "@images/handheld-scanner-icon-500X400.png";

/**
 * ListEmptyState - 空狀態組件
 */
const ListEmptyState = ({
    message = "尚無資料",
    icon,
    className = "",
    ...otherProps
}) => {

    return (
        <Box
            className={`inventory-empty-state ${className}`}
            {...otherProps}
        >
            <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Typography
                    variant="body2"
                    className="font-color-2 text-center m-0"
                >
                    {message}
                </Typography>

                {icon ? (
                    <Box style={{ opacity: 0.8 }}>
                        {icon}
                    </Box>
                ) : (
                    <img style={{width: '250px', height: '200px', opacity: 0.8}} src={handheldScannerIcon} alt={message} />
                )}
            </Stack>
        </Box>
    );
};

ListEmptyState.propTypes = {
    message: PropTypes.string,
    icon: PropTypes.node,
    className: PropTypes.string,
};

export default ListEmptyState;
